export const Constants = Object.freeze({

  FR_LANG_KEY: 'fr',
  ES_LANG_KEY: 'es',
  EN_LANG_KEY: 'en',

  // GRTGAZ CUSTOMIZATION
  PRIVACY_MODE_SLUG: 'grtgaz',

  // HEADER
  HAS_SEEN_HEADER_TUTORIAL: 'userHasSeenTutorial',

  BLOG_URL: 'https://blog.noos.global/',
  APP_URL: 'https://app.noos.global/',
  STATIC_PAGE_URL: 'https://www.noos.global/',
  HELLO_NOOS_EMAIL: 'hello@noos.global',

  // Landing presentation mail contents

  PRESENTATION_MAIL_CONTENT_FR: 'mailto:?subject=Connaissez-vous%20NooS%20-%20outil%20RSE%2C%20RH%20et%20impact%20%3F&body=Bonjour%2C%20%0D%0A%0D%0AJe%20souhaite%20vous%20pr%C3%A9senter%20NooS%2C%20un%20outil%20qui%20pourrait%20%C3%AAtre%20tr%C3%A8s%20utile%20au%20sein%20de%20notre%20entreprise%20%3B)%0D%0A%0D%0AEn%20quelques%20mots%2C%20NooS%20est%20une%20solution%20RSE%20360%C2%BA%20qui%20permet%20aux%20entreprises%20d%E2%80%99agir%20pour%20la%20plan%C3%A8te%20et%20la%20soci%C3%A9t%C3%A9%20tout%20en%20mobilisant%20leurs%20collaborateurs%20autour%20de%20leurs%20objectifs%20d%E2%80%99impact.%20%0D%0A%0D%0AAvec%20l%E2%80%99outil%20NooS%2C%20les%20entreprises%20peuvent%20impliquer%20leurs%20collaborateurs%20dans%20le%20choix%20des%20causes%20sociales%20ou%20environnementales%20qu%E2%80%99elles%20soutiennent%20et%20suivre%20l%E2%80%99impact%20de%20leur%20engagement%20en%20temps%20r%C3%A9el.%20%0D%0A%0D%0ALes%20entreprises%20peuvent%20%C3%A9galement%20encourager%20leurs%20collaborateurs%20%C3%A0%20faire%20plus%20de%20mani%C3%A8re%20ludique%20et%20int%C3%A9ractive%20%C3%A0%20travers%20des%20d%C3%A9fis%20sociaux%20et%20environnementaux%2C%20des%20opportunit%C3%A9s%20de%20b%C3%A9n%C3%A9volat%20et%20du%20contenu%20qualitatif.%20%0D%0A%0D%0AEn%20moyenne%2C%2054%2C2%25%20des%20collaborateurs%20utilisent%20l%E2%80%99outil%20apr%C3%A8s%2012%20semaines%20avec%20une%20satisfaction%20de%209%2C3%2F10.%20De%20nombreuses%20entreprises%20de%20tous%20secteurs%20et%20toutes%20tailles%20font%20d%C3%A9j%C3%A0%20la%20diff%C3%A9rence%20avec%20NooS.%20Vous%20pouvez%20consulter%20leur%20impact%20positif%20ici%20%F0%9F%91%89%20https%3A%2F%2Fapp.noos.global%2Ffr%2Fbrands%20%0D%0A%0D%0AD%E2%80%99autres%20liens%20utiles%3A%0D%0A%0D%0A%E2%80%A2%20En%20savoir%20plus%20sur%20NooS%3A%20https%3A%2F%2Fwww.noos.global%20%0D%0A%E2%80%A2%20Prendre%20RV%20avec%20l%E2%80%99%C3%A9quipe%20NooS%3A%20https%3A%2F%2Fwww.noos.global%2Fdemo-outil-rse-engagement-collaborateurs%2F%20%0D%0A%E2%80%A2%20Avoir%20une%20d%C3%A9mo%3A%20https%3A%2F%2Fwww.noos.global%2Fdemo-outil-rse-engagement-collaborateurs%2F%0D%0A%0D%0AQu%E2%80%99en%20pensez-vous%20%3F%0D%0A%0D%0ABonne%20journ%C3%A9e%0D%0A',
  PRESENTATION_MAIL_CONTENT_EN: 'mailto:?subject=Do%20you%20know%20NooS%20-%20CSR%2C%20HR%20and%20impact%20tool%3F&body=Hi%2C%0D%0A%0D%0AI%20would%20like%20to%20introduce%20you%20to%20NooS%2C%20a%20tool%20that%20could%20be%20very%20useful%20to%20our%20company%20%3B)%0D%0A%0D%0AIn%20a%20few%20words%2C%20NooS%20is%20a%20360%C2%BA%20CSR%20solution%20that%20helps%20companies%20to%20act%20for%20the%20planet%20and%20society%20while%20engaging%20their%20employees%20around%20their%20impact%20goals.%20%0D%0A%0D%0AWith%20the%20NooS%20tool%2C%20companies%20can%20involve%20their%20employees%20in%20choosing%20the%20causes%20they%20support%20and%20track%20the%20impact%20of%20their%20commitment%20in%20real%20time.%20%0D%0A%0D%0ACompanies%20can%20also%20encourage%20their%20employees%20to%20do%20more%20%20in%20a%20fun%20and%20interactive%20way%20through%20social%20and%20environmental%20challenges%2C%20volunteering%20opportunities%20and%20qualitative%20content.%0D%0A%0D%0AOn%20average%2C%2054%2C2%25%20of%20employees%20use%20the%20tool%20after%2012%20weeks%20with%20a%20satisfaction%20rating%20of%209.3%2F10.%20A%20lot%20of%20companies%20from%20all%20sectors%20and%20of%20all%20sizes%20are%20already%20making%20a%20difference%20with%20NooS.%20You%20can%20see%20their%20positive%20impact%20here%20%F0%9F%91%89%20https%3A%2F%2Fapp.noos.global%2Fen%2Fbrands%0D%0A%0D%0AHere%20are%20other%20useful%20links%3A%0D%0A%0D%0A%E2%80%A2%20Learn%20more%20about%20NooS%3A%20https%3A%2F%2Fwww.noos.global%2Fen%0D%0A%E2%80%A2%20Meet%20the%20NooS%20team%3A%20https%3A%2F%2Fwww.noos.global%2Fen%2Fdemo-csr-tool-employees%2F%0D%0A%E2%80%A2%20Get%20a%20demo%3A%20https%3A%2F%2Fwww.noos.global%2Fen%2Fdemo-csr-tool-employees%2F%0D%0A%0D%0ALet%20me%20know%20what%20you%20think!%0D%0A%0D%0AHave%20a%20great%20day%0D%0A%0D%0A',
  PRESENTATION_MAIL_CONTENT_ES: 'mailto:?subject=%C2%BFConoces%20a%20NooS%20-%20herramienta%20de%20RSC%2C%20RRHH%20e%20impacto%3F&body=Hola%2C%20%0D%0A%0D%0AMe%20gustar%C3%ADa%20presentarle%20NooS%2C%20una%20herramienta%20que%20podr%C3%ADa%20ser%20muy%20%C3%BAtil%20para%20nuestra%20empresa%20%3B)%0D%0A%0D%0AEn%20pocas%20palabras%2C%20NooS%20es%20una%20soluci%C3%B3n%20360%C2%BA%20de%20RSC%20que%20permite%20a%20las%20empresas%20actuar%20por%20el%20bien%20del%20planeta%20y%20de%20la%20sociedad%20movilizando%20al%20mismo%20tiempo%20a%20sus%20empleados%20en%20torno%20a%20sus%20objetivos%20de%20impacto.%20%0D%0A%0D%0ACon%20la%20herramienta%20NooS%2C%20las%20empresas%20pueden%20involucrar%20a%20sus%20empleados%20en%20la%20elecci%C3%B3n%20de%20las%20causas%20que%20apoya%20y%20seguir%20el%20impacto%20de%20su%20compromiso%20en%20tiempo%20real.%20%0D%0A%0D%0ALas%20empresas%20tambi%C3%A9n%20pueden%20animar%20a%20sus%20empleados%20a%20hacer%20m%C3%A1s%20de%20forma%20divertida%20e%20interactiva%20mediante%20retos%20sociales%20y%20medioambientales%2C%20oportunidades%20de%20voluntariado%20y%20contenidos%20cualitativos.%20%0D%0A%0D%0APor%20t%C3%A9rmino%20medio%2C%20el%2054%2C2%25%20de%20los%20empleados%20utiliza%20la%20herramienta%20al%20cabo%20de%2012%20semanas%20con%20un%20%C3%ADndice%20de%20satisfacci%C3%B3n%20de%209%2C3%2F10.%20Muchas%20empresas%20de%20todos%20los%20sectores%20y%20tama%C3%B1os%20ya%20est%C3%A1n%20marcando%20la%20diferencia%20con%20NooS.%20Puede%20ver%20su%20impacto%20positivo%20aqu%C3%AD%20%F0%9F%91%89%20https%3A%2F%2Fapp.noos.global%2Fes%2Fbrands%0D%0A%0D%0AOtros%20enlaces%20%C3%BAtiles%3A%0D%0A%0D%0A%E2%80%A2%20M%C3%A1s%20informaci%C3%B3n%20acerca%20de%20NooS%3A%20https%3A%2F%2Fwww.noos.global%2Fes%0D%0A%E2%80%A2%20Contactar%20con%20el%20equipo%20NooS%3A%20https%3A%2F%2Fwww.noos.global%2Fes%2Fdemo-herramienta-rsc-movilizacion-empleados%2F%0D%0A%E2%80%A2%20Solicitar%20una%20demostraci%C3%B3n%3A%20https%3A%2F%2Fwww.noos.global%2Fes%2Fdemo-herramienta-rsc-movilizacion-empleados%2F%0D%0A%0D%0A%C2%BFQu%C3%A9%20le%20parece%3F%0D%0A%0D%0A%C2%A1Que%20tenga%20un%20buen%20d%C3%ADa!%0D%0A%0D%0A%0D%0A',

  // Donation amounts
  DONATION_AMOUNTS_TEXTS: ['10€', '25€', '50€', '100€', '200€'],
  DONATION_AMOUNTS_VALUES: [10, 25, 50, 100, 200],
  MINIMUM_DONATION_AMOUNT: 1,
  MAXIMUM_DONATION_AMOUNT: 2000,

  // Time slots by 30 minutes spans
  HALF_HOUR_INTERVALS: [
    '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30',
    '05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30',
    '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
    '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30', '24:00'
  ],


  // Initiative types
  INITIATIVE_TYPE_NGO_PROJECT: 'project',
  INITIATIVE_TYPE_VOLUNTEERING: 'mission',

  // Buttons
  // Naming: TYPE (Ej. TYPE_PILL) | COLOR (Ej. DARK_BLUE) | BORDER TYPE (Ej. LINE) | SIZE (Ej. N)

  // VERY DARK BLUE
  BUTTON_TYPE_DEFAULT_VERY_DARK_BLUE_LINE_N: 'ns-button-very-dark-blue-line-normal',

  // DARK BLUE
  BUTTON_TYPE_DEFAULT_DARK_BLUE_SOLID_M: 'ns-button-dark-blue-solid-medium', // Old naming
  BUTTON_TYPE_DEFAULT_DARK_BLUE_SOLID_S: 'ns-button-dark-blue-solid-small', // Old naming

  BUTTON_TYPE_DEFAULT_DARK_BLUE_STROKE_M: 'ns-button-dark-blue-stroke-normal', // Old naming
  BUTTON_TYPE_DEFAULT_DARK_BLUE_STROKE_T: 'ns-button-dark-blue-stroke-tiny', // Old naming

  BUTTON_TYPE_DEFAULT_DARK_BLUE_GHOST_N: 'ns-button-dark-blue-ghost-normal',
  BUTTON_TYPE_DEFAULT_DARK_BLUE_GHOST_S: 'ns-button-dark-blue-ghost-small',

  // GREEN
  BUTTON_TYPE_DEFAULT_GREEN_SOLID_S: 'ns-button-green-solid-small', // Old naming

  BUTTON_TYPE_DEFAULT_GREEN_FILLED_B: 'ns-button-green-filled-big',
  BUTTON_TYPE_DEFAULT_GREEN_FILLED_N: 'ns-button-green-filled-normal',
  BUTTON_TYPE_DEFAULT_GREEN_FILLED_S: 'ns-button-green-filled-small',

  BUTTON_TYPE_DEFAULT_GREEN_LINE_B: 'ns-button-green-line-big',
  BUTTON_TYPE_DEFAULT_GREEN_STROKE_M: 'ns-button-green-line-normal', // Old naming

  BUTTON_TYPE_DEFAULT_GREEN_GHOST_B: 'ns-button-green-ghost-big',
  BUTTON_TYPE_DEFAULT_GREEN_GHOST_N: 'ns-button-green-ghost-normal',
  BUTTON_TYPE_DEFAULT_GREEN_GHOST_S: 'ns-button-green-ghost-small',


  BUTTON_TYPE_PILL_LIGHT_GREEN_SOLID_L: 'ns-button-pill-light-green-solid-large', // Old naming
  BUTTON_TYPE_PILL_LIGHT_GREEN_SOLID_S: 'ns-button-pill-light-green-solid-small', // Old naming

  // ALT GREEN
  BUTTON_TYPE_DEFAULT_ALT_GREEN_FILLED_S: 'ns-button-alt-green-filled-small',

  // LIGHT GREEN
  BUTTON_TYPE_DEFAULT_LIGHT_GREEN_FILLED_B: 'ns-button-light-green-filled-big',
  BUTTON_TYPE_DEFAULT_LIGHT_GREEN_FILLED_N: 'ns-button-light-green-filled-normal',
  BUTTON_TYPE_DEFAULT_LIGHT_GREEN_FILLED_S: 'ns-button-light-green-filled-small',

  BUTTON_TYPE_DEFAULT_LIGHT_GREEN_LINE_B: 'ns-button-light-green-line-big',

  BUTTON_TYPE_DEFAULT_LIGHT_GREEN_GHOST_S: 'ns-button-light-green-ghost-small',

  // YELLOW
  BUTTON_TYPE_DEFAULT_YELLOW_FILLED_VB: 'ns-button-yellow-filled-very-big',
  BUTTON_TYPE_DEFAULT_YELLOW_FILLED_B: 'ns-button-yellow-filled-big',
  BUTTON_TYPE_DEFAULT_YELLOW_SOLID_M: 'ns-button-yellow-filled-normal', // Old naming
  BUTTON_TYPE_DEFAULT_YELLOW_FILLED_S: 'ns-button-yellow-filled-small', // Old naming

  BUTTON_TYPE_DEFAULT_YELLOW_LINE_N: 'ns-button-yellow-line-normal',

  // DARK GREY
  BUTTON_TYPE_DEFAULT_DARK_GREY_LINE_B: 'ns-button-dark-grey-line-big',
  BUTTON_TYPE_DEFAULT_DARK_GREY_LINE_N: 'ns-button-dark-grey-line-normal',

  BUTTON_TYPE_PILL_DARK_GREY_TRANSPARENT_L: 'ns-button-pill-dark-grey-transparent-large', // Old naming
  BUTTON_TYPE_PILL_DARK_GREY_TRANSPARENT_M: 'ns-button-pill-dark-grey-transparent-medium', // Old naming
  BUTTON_TYPE_PILL_DARK_GREY_TRANSPARENT_S: 'ns-button-pill-dark-grey-transparent-small', // Old naming

  // RED
  BUTTON_TYPE_DEFAULT_RED_FILLED_B: 'ns-button-red-filled-big',
  BUTTON_TYPE_DEFAULT_RED_FILLED_N: 'ns-button-red-filled-normal',

  BUTTON_TYPE_DEFAULT_RED_LINE_N: 'ns-button-red-line-normal',


  BUTTON_TYPE_DEFAULT_RED_GHOST_N: 'ns-button-red-ghost-normal',


  // HTML BUTTONS
  HTML_BUTTON_TYPE_SUBMIT: 'submit',

  // Form Fields
  FORM_CONTROL_TEXT_TYPE: 'text',
  FORM_CONTROL_NUMBER_TYPE: 'number',

  // Notification Types
  N_TYPE_QU_COMMENT: 'quiz_comment',
  N_TYPE_RC_COMMENT: 'reading_content_comment',
  N_TYPE_CH_COMMENT: 'challenge_comment',
  N_TYPE_QU_COMMENT_LIKE: 'quiz_comment_like',
  N_TYPE_RC_COMMENT_LIKE: 'reading_comment_like',
  N_TYPE_CH_COMMENT_LIKE: 'challenge_comment_like',
  N_TYPE_QU_COMMENT_R: 'quiz_comment_reply',
  N_TYPE_RC_COMMENT_R: 'reading_comment_reply',
  N_TYPE_CH_COMMENT_R: 'challenge_comment_reply',

  // General Query Parameters
  QPARAM_ACTION: 'action',
  QPARAM_NAV_CONTEXT: 'navigationContext',

  // Navigation contexts | Identifies the origin of the opened modal or page.
  // When users navigate back, they are redirected to their previous location.
  NAV_CONTEXT_HOME: 'home',

  // HTTP Error Handing
  ERROR_SOURCE_NAME: 'Angular Frontend',

  // Frontend Log
  LOGIN_COMPONENT_NAME: 'log-in.component.ts',
  SIGNUP_COMPONENT_NAME: 'sign-up.component.ts',
  HOME_COMPONENT_NAME: 'home.component.ts',
  LEARNING_MODAL_COMPONENT_NAME: 'learning-content-modal.component.ts',
  CAMPAIGN_COMPONENT_NAME: 'campaign.component.ts',

  NGONINIT_FUNCTION_NAME: 'ngOnInit',
  HANDLE_ERROR_RESPONSE_FUNCTION_NAME: 'handleErrorResponse',
  COMPLETE_QUIZ_SERVICE_CALL_NAME: 'completeLacQuiz',
  COMPLETE_RC_SERVICE_CALL_NAME: 'completeLacReading',
  CLOSE_LC_MODAL_CALL_NAME: 'onCloseModalWithActivityCompletion',

  // Redirections

  RETURN_URL_PARAM_KEY: 'returnUrl',
  // User Login Redirections
  LOGIN_REDIRECTION_COMPANY_KEY: 'company',

  // Segmentation
  HOTJAR_USER_WITH_PLEDGE_EVENT: 'logged_user_with_pledge',

  // Push Notifications
  PUSH_WAIT_SECONDS_TO_SHOW_SOFT_ASK: 15000,
  PUSH_WAIT_DAYS_TO_ASK_AGAIN: 30,

  // Sponsorship Program for Employees
  SPONSORSHIP_PROGRAM_FOR_EMPLOYEES_URL_FR: 'https://noos-global.notion.site/Programme-de-parrainage-NooS-Guide-pour-les-collaborateurs-2d6f64f2a3db4bfc8c5e00a849be0d94?pvs=4',
  SPONSORSHIP_PROGRAM_FOR_EMPLOYEES_URL_EN: 'https://noos-global.notion.site/NooS-Sponsorship-Program-Guidelines-for-Employees-24ef7682ce1f44a590ef51c196996dde?pvs=4',
  SPONSORSHIP_PROGRAM_FOR_EMPLOYEES_URL_ES: 'https://noos-global.notion.site/Programa-de-patrocinio-de-NooS-Gu-a-para-empleados-dd14e4645b0e4772840a344ff02fbead?pvs=4',

  // STATIC PAGE LINKS (WordPress)
  RSE_TOOL_LINK_FR: 'https://www.noos.global/outil-rse-engagement-collaborateurs/',
  RSE_TOOL_LINK_EN: 'https://www.noos.global/en/csr-tool-mobilize-employees/',
  RSE_TOOL_LINK_ES: 'https://www.noos.global/es/herramienta-rsc-movilizacion-empleados/',
  EXPERTISE_IMPACT_LINK_FR: 'https://www.noos.global/experts-rse-impact/',
  EXPERTISE_IMPACT_LINK_EN: 'https://www.noos.global/en/impact-csr-experts/',
  EXPERTISE_IMPACT_LINK_ES: 'https://www.noos.global/es/expertos-impacto-rsc/',
  DEMO_LINK_FR: 'https://www.noos.global/contact',
  DEMO_LINK_EN: 'https://www.noos.global/en/contact',
  DEMO_LINK_ES: 'https://www.noos.global/es/contacto',
  ABOUT_NOOS_LINK_FR: 'https://www.noos.global/noos-global/',
  ABOUT_NOOS_LINK_EN: 'https://www.noos.global/en/about-noos-global/',
  ABOUT_NOOS_LINK_ES: 'https://www.noos.global/es/acerca-noos-global/',
  WHO_WE_ARE_LINK_FR: 'https://www.noos.global/equipe-noos-global/',
  WHO_WE_ARE_LINK_EN: 'https://www.noos.global/en/noos-global-team/',
  WHO_WE_ARE_LINK_ES: 'https://www.noos.global/es/equipo-noos-global/',
  CSR_CLIENTS_LINK_FR: 'https://www.noos.global/impliquer-client-demarche-rse/',
  CSR_CLIENTS_LINK_EN: 'https://www.noos.global/en/engage-customers-csr-impact/',
  CSR_CLIENTS_LINK_ES: 'https://www.noos.global/es/involucrar-cliente-estrategia-rsc/',
  CARBON_COMPENSATION_LINK_FR: 'https://www.noos.global/empreinte-carbone/',
  CARBON_COMPENSATION_LINK_EN: 'https://www.noos.global/en/carbon-footprint-compensation-projects/',
  CARBON_COMPENSATION_LINK_ES: 'https://www.noos.global/es/proyectos-compensacion-huella-carbono/',
});
